export default "<p>outsource-students-data works!</p>\n"